import React, { useState, useEffect } from 'react'
import axios from 'axios';

import './PDF.css'
import "./ReportEditor.css"
import Sidebar from "../../shared/sidebar/Sidebar"
import Navbar from "../../shared/navbar/Navbar"

import { Editor } from "react-draft-wysiwyg";
import {  EditorState, ContentState, convertFromHTML} from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ErrorMessages from '../../shared/errormessages/ErrorMessages';

import { stateToHTML } from 'draft-js-export-html';

const ReportEditor = (props) => {

  const [pageState, setPageState] = useState({ loading: false})
  const [Type, setType] = useState(props.type);
  const [editorState, setEditorState] = useState(EditorState.createEmpty())

  //const[htmlContent, setHtmlContent] = useState()

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    //setHtmlContent(stateToHTML( editorState.getCurrentContent()));
  }
  const [errors, setErrors] = useState("")

  useEffect(()=>{
    if(pageState.loading == false){
      setEditorState(EditorState.createEmpty());
      axios.get('/template/getcontent?type=' + props.type)
        .then(function (response) {
            if(response.data.status == "success"){
              const textContent = response.data.content;
              const blocksFromHTML = convertFromHTML(textContent);
              const content = ContentState.createFromBlockArray(
                  blocksFromHTML.contentBlocks,
                  blocksFromHTML.entityMap
              );
              setEditorState(EditorState.createWithContent(content));
              setErrors("");
              setPageState({loading: true});

              //const htmlContent = parse(textContent);
              //const newEditorState = EditorState.createWithContent(ContentState.createFromText(textContent));
              //setEditorState(newEditorState);
            }
            else{
              setErrors(response.data.message);
            }
        })
        .catch(function (error) {
          setErrors(error.message);
        });
    }
  })

  const handleSubmitClick =(e)=>{
    e.preventDefault();
    
    axios.post('/template/setcontent', {
      Type: Type,
      Content: stateToHTML( editorState.getCurrentContent())
    })
    .then(function (response) {
      if(response.data.status == "success"){
        setErrors("");
      }
      else{
        setErrors(response.data.message);
      }
    })
    .catch(function (error) {
      setErrors(error.message);
    });
  };

  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar title={props.type == "report" ? "Report Editor" : "Group Report Editor"}/>
        <form className="form-editor">
        <ErrorMessages message={errors}/>
          <button type="button" className="btn btn-primary" onClick={handleSubmitClick} >Save Template</button>
        </form>
        <Editor
              editorState={editorState}
              // toolbarClassName="toolbar-editor"
              wrapperClassName="wrapper-editor"
              editorClassName="html-editor A4"
              onEditorStateChange={onEditorStateChange}
              spellCheck={true}
              toolbar={{
                options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history']
              }}
              hashtag={{}}
            />
      </div>
    </div>
  )
}

export default ReportEditor